import { render, staticRenderFns } from "./StudyResultsIndex.vue?vue&type=template&id=2140fe37&"
import script from "./StudyResultsIndex.vue?vue&type=script&lang=js&"
export * from "./StudyResultsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports